import { Box, IconButton } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';

const ActionCell = ({
    params, 
    rows, 
    setRows
}) => {

    return (
        <>
            <Box 
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%', 
                    height: '100%'
                }}
            >
                <IconButton 
                    color="error" 
                    onClick={() => {
                        setRows(rows.filter(row => row.id !== params.row.id))
                    }}
                >
                    <DeleteIcon />
                </IconButton>
            </Box>
        </>
    )
}

export {
    ActionCell
}